import { fetchConfig, formatMoney } from '@theme/utilities';
import { CartAddEvent, ThemeEvents } from '@theme/events';

class HdtBundleRecommend extends HTMLElement {
  connectedCallback() {
    this.mergeAtc = this.dataset.mergeAtc !== 'false';
    this.cartAddUrl = this.dataset.cartAddUrl;
    this.mainForm = document.getElementById(this.dataset.mainFormId);
    this.submitBtn = this.mainForm?.querySelector('[type="submit"][name="add"]');

    this._onSubmit = this._onSubmit.bind(this);
    if (this.mergeAtc && this.mainForm) {
      this.mainForm.addEventListener('submit', this._onSubmit, true);
    }

    // 冒泡阶段：不拦截，让 hdt-bundle-product 先更新价格；再补充描述等
    this.addEventListener('change', (e) => {
      const target = e.target;
      if (!target?.matches?.('[name="items[][id]"]')) return;
      if (!this.contains(target)) return;
      requestAnimationFrame(() => this._syncBundleItemExtras(target));
    });

    this.querySelectorAll('[data-bundle-qty-minus]').forEach((btn) => {
      btn.addEventListener('click', () => this._changeQty(btn, -1));
    });
    this.querySelectorAll('[data-bundle-qty-plus]').forEach((btn) => {
      btn.addEventListener('click', () => this._changeQty(btn, 1));
    });
  }

  disconnectedCallback() {
    if (this.mainForm) {
      this.mainForm.removeEventListener('submit', this._onSubmit, true);
    }
  }

  _syncBundleItemExtras(select) {
    const item = select.closest('hdt-bundle-product');
    if (!item) return;
    const opt = select.options[select.selectedIndex];
    if (!opt) return;

    const price = Number(opt.dataset.price);
    const compare = Number(opt.dataset.cpprice || price);

    const priceWrap = item.querySelector('[update-price]');
    if (priceWrap) {
      const compareEl = priceWrap.querySelector('.hdt-compare-at-price');
      const compareMoney = priceWrap.querySelector('.hdt-compare-at-price .hdt-money');
      const priceMoney = priceWrap.querySelector('.hdt-price .hdt-money');

      if (compareMoney) {
        compareMoney.outerHTML = `<span class="hdt-money">${formatMoney(compare)}</span>`;
      }
      if (compareEl) {
        compareEl.toggleAttribute('hidden', compare <= price);
      }
      if (priceMoney) {
        priceMoney.outerHTML = `<span class="hdt-money">${formatMoney(price)}</span>`;
      }
    }

    const img = item.querySelector('[update-img]');
    if (img?.tagName === 'IMG' && opt.dataset.img) {
      img.src = opt.dataset.img;
    }

    const qtyInput = item.querySelector('[update-qty], [data-bundle-qty]');
    if (qtyInput && opt.dataset.qty) {
      qtyInput.value = opt.dataset.qty;
    }

    const descEl = item.querySelector('[data-bundle-desc]');
    if (descEl && opt.dataset.desc) {
      descEl.textContent = opt.dataset.desc;
    }

    document.dispatchEvent(new CustomEvent('currency:update'));
  }

  _changeQty(btn, delta) {
    const item = btn.closest('hdt-bundle-product');
    const input = item?.querySelector('[data-bundle-qty]');
    if (!input) return;
    const min = Number(input.min) || 1;
    const max = input.max ? Number(input.max) : null;
    let val = Number(input.value) || min;
    val += delta;
    if (val < min) val = min;
    if (max && val > max) val = max;
    input.value = val;
  }

  _getSelectedItems() {
    return [...this.querySelectorAll('hdt-bundle-product.is-checked')].map((item) => {
      const id = item.querySelector('[name="items[][id]"]')?.value;
      const qty = Number(item.querySelector('[data-bundle-qty]')?.value) || 1;
      return id ? { id: Number(id), quantity: qty } : null;
    }).filter(Boolean);
  }

  _getMainLineItem() {
    const form = this.mainForm;
    if (!form) return null;
    const idInput = form.querySelector('[name="id"]:not([disabled])') || form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[name="quantity"]');
    const id = idInput?.value;
    if (!id) return null;
    return {
      id: Number(id),
      quantity: Number(qtyInput?.value) || 1,
    };
  }

  _setLoading(loading) {
    if (!this.submitBtn) return;
    this.submitBtn.disabled = loading;
    const spinner = this.submitBtn.querySelector('.hdt-loading__spinner');
    if (spinner) spinner.hidden = !loading;
  }

  async _onSubmit(e) {
    const extras = this._getSelectedItems();
    if (!extras.length) return;

    const mainItem = this._getMainLineItem();
    if (!mainItem?.id) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const items = [mainItem, ...extras];
    this._setLoading(true);

    try {
      const res = await fetch(
        this.cartAddUrl,
        fetchConfig('json', { body: JSON.stringify({ items }) })
      );
      const data = await res.json();
      if (!res.ok) {
        throw data;
      }

      const cartRes = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
      const cart = await cartRes.json();

      document.dispatchEvent(
        new CartAddEvent(
          cart,
          this.dataset.sectionId,
          null,
          window.themeHDN?.settings?.actionAfterATC,
          'bundle-recommend'
        )
      );
    } catch (err) {
      document.dispatchEvent(
        new CustomEvent(ThemeEvents.cartError, {
          bubbles: true,
          detail: { message: err?.description || err?.message || 'Cart error' },
        })
      );
    } finally {
      this._setLoading(false);
    }
  }
}

if (!customElements.get('hdt-bundle-recommend')) {
  customElements.define('hdt-bundle-recommend', HdtBundleRecommend);
}
